// photoName komt uit de gegenereerde SSOT (FileTypes WHERE Area = Photo, zie EnumExporter).
// Niet handmatig bewerken: een wijziging gaat via de DB + `npm run generate:enums`.
// logoName blijft voorlopig handmatig tot FileVariantType een Area-discriminator heeft (fase 2/3).
import { photoName } from 'src/assets/common/enums/photo-name.g';

export { photoName };
export type { TPhotoName } from 'src/assets/common/enums/photo-name.g';

export const logoName = {
    logo: 'logo',
    logoEmail: 'logoEmail',
    logoIcon: 'logoIcon',
} as const;

export const imageName = {...logoName, ...photoName} as const;

export type TLogoName = (typeof logoName)[keyof typeof logoName];
export type TImageName = (typeof imageName)[keyof typeof imageName];
